module.exports = __webpack_public_path__ + "static/media/easygoing_2.b25bccd3.svg";